import { render, staticRenderFns } from "./Galeria.vue?vue&type=template&id=717ecd20"
import script from "./Galeria.vue?vue&type=script&lang=js"
export * from "./Galeria.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports